import { useIntl } from 'react-intl'
import './SummaryChart.scss'
import Chart from '../Chart/Chart'
import { connect } from 'react-redux'
import { useState } from 'react'

export interface SummaryChartProps {
    chartData: any
}

const SummaryChart = (props: SummaryChartProps) => {
    const { chartData } = props

    const componentClass = 'smart-modals-new-activity-approval-action-summary-chart'
    const intl = useIntl()

    const [options] = useState({
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
            },
        },
    })

    return (
        <div className={componentClass}>
            <h3 className={`${componentClass}__title`}>
                {intl.formatMessage({
                    id: 'modals.new.activity.approval.action.summary.chart.title',
                    defaultMessage: 'List Summary',
                })}
            </h3>
            <div className={`${componentClass}__chart-container`}>
                <div className={`${componentClass}__chart`}>
                    <Chart type="pie" data={chartData} options={options} />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => ({})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(SummaryChart)
